
import React from 'react';
import Rental from 'views/ReadingClub';

const RentalPage = () => {
  return <Rental />;
};

export default RentalPage;
